import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { SiteAuditDocumentsReportFilterParams } from '~bank-reports/types/SiteAuditDocumentsReport'

export const siteAuditDocumentsReportQueryOptions = (deps: Partial<SiteAuditDocumentsReportFilterParams>) =>
  queryOptions({
    queryKey: ['siteAuditDocumentsReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportSite, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
